import { Pipe, PipeTransform } from '@angular/core';
import { InstallationCustomerCommentsPluginService } from './customer-comments.service';
@Pipe({
    name: 'customercommentfrom',
    standalone: false
})
export class CustomerCommentFromPipe implements PipeTransform {
  public points: any[];
  constructor(private service: InstallationCustomerCommentsPluginService) {
    this.points = this.service.getCommentFromTargets();
  }
  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.points);
  }
}
